import event, {EVENTS} from '../../lib/event';
import {focusBlock} from '../highlight.jsx';
import {getAllBlocks} from '../blocks';
import StepsRuntime from '../steps-runtime';
import {workspaceSafeUndo} from '../utils';
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

/**
 * 删除某个块
 * @param {string} tips - 提示信息
 * @param {string} id - 待删除的 block 全局 id
 * @returns {array} 成功时返回 true
 */
export default function removeBlock ({tips, id}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve, reject) => {
        event.once(EVENTS.STEP_ABORT, ()=>{
            event.removeAllListeners(EVENTS.END_DRAG_AND_MOVE);
            reject('Step Abort');
        });
        if (!tips) {
            tips = "将积木块拖动到左侧删除";
        }
        if (mode) {
            window.stepsRuntime.insertTips(_index, tips);
            if (mode !== GUIDE_MODE) {
                return new Promise(resolve => {
                    resolve();
                })
            }
        }else {
            Audio.tts(tips);
        }
        const sourceId = stepsRuntime.getBlockId(id);
        focusBlock({source: {id: sourceId}, target:{position: {absolute: true, x: document.querySelector('.blocklySvg').getBoundingClientRect().left / 2, y: 400}}, tips, reject}, mode, _index);
        const startBlocksCnt = getAllBlocks().length;
        event.once(EVENTS.END_DRAG_AND_MOVE, () => {
            const endBlocksCnt = getAllBlocks().length;
            if (endBlocksCnt < startBlocksCnt) { // 删除块，块数量变少
                const allBlocks = getAllBlocks();
                if (allBlocks.find(b => b.id === sourceId)) {
                    workspaceSafeUndo()
                        .then(() => {
                            reject('指定块没被删除');
                        });
                } else {
                    resolve(true);
                }
            } else {
                workspaceSafeUndo()
                    .then(() => {
                        reject('没有块被删除');
                    });
            }
        });
    });
}
